import { createI18n } from 'vue-i18n';
// import { useSettingStore } from '@/stores/settingStore';
import en from '@/locales/en.json';
import ar from '@/locales/ar.json';

const messages = {
  en,
  ar,
};

// Get initial locale from settingStore if available
const getInitialLocale = () => {
  // Access stored language if available in localStorage
  const storedSettings = localStorage.getItem('settingStore');
  if (storedSettings) {
    const settings = JSON.parse(storedSettings);
    return settings.language || 'en';
  }
  return 'en';
};

const i18n = createI18n({
  locale: getInitialLocale(), // Use stored language
  fallbackLocale: 'en',
  messages,
});

export default i18n;
export const t = i18n.global.t;
export const locale = i18n.global.locale;